import { connect } from "react-redux";
import CivilCheckout from "./civilCheckout";
import { bindActionCreators } from "redux";
import {
  getCivilCheckList,
  postCivilCheckList,
} from "services/redux/installation/civilCheckList/action";
import { getGateInfo } from "services/redux/installation/handOver/action";
import { documentUploadUrl } from "services/redux/fileUpload/action";

const mapStateToProps = (state) => ({
  civilData: state.civilReducer.civilData,
  gateInfo: state.handOverReducer.gateInfo,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getCivilCheckList,
      getGateInfo,
      documentUploadUrl,
      postCivilCheckList,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(CivilCheckout);
